module.exports = __webpack_public_path__ + "../resources/img/ic_re_arrow_right_default.1529349e.svg";